export const EXCLUDING_COPY_ACTIONS = [
  'brainstormMindmap',
  'expandMindmap',
  'makeItReal',
  'createSlides',
  'createQuiz',
  'createMermaid',
];

export const EXCLUDING_INSERT_ACTIONS: string[] = [];

export const IMAGE_ACTIONS: string[] = [];

export const generatingStages: {
  [key in keyof Partial<BlockSuitePresets.AIActions>]: string[];
} = {
  makeItReal: ['Coding for you', 'Rendering the code'],
  brainstormMindmap: ['Thinking about this topic', 'Rendering mindmap'],
  expandMindmap: ['Analyzing transcript', 'Identifying nodes to expand', 'Expanding mindmap'],
  createSlides: ['Thinking about this topic', 'Rendering slides'],
  createQuiz: ['Creating quiz questions', 'Generating quiz'],
  createMermaid: ['Creating diagram', 'Rendering diagram'],
};

export const INSERT_ABOVE_ACTIONS: string[] = [];
